var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 2.5L6.32533 7.84167C6.00866 8.15833 5.83366 8.58333 5.83366 9.025V15.55C5.83366 16.625 6.70866 17.5 7.78366 17.5H14.5337C15.1253 17.5 15.667 17.1917 15.967 16.6917L18.192 11.5667C18.2837 11.3583 18.3337 11.1333 18.3337 10.9V10C18.3337 9.08333 17.5837 8.33333 16.667 8.33333H12.0837L12.8503 4.45833C12.892 4.275 12.867 4.075 12.7837 3.90833C12.592 3.53333 12.3503 3.19167 12.0503 2.89167L11.667 2.5ZM4.16699 8.33333H1.66699V17.5H4.16699C4.62533 17.5 5.00033 17.125 5.00033 16.6667V9.16667C5.00033 8.70833 4.62533 8.33333 4.16699 8.33333Z",
    fill: "#2D9BB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpOn);
export default __webpack_public_path__ + "static/media/ThumbsUpOn.7b50d09a4e757242df2cb80c9abbc279.svg";
export { ForwardRef as ReactComponent };